/* eslint-disable unicorn/filename-case -- Expo resolves this platform entry by its fixed name. */
import React, { Suspense, lazy } from "react";
import { initializeBrowserTelemetry } from "./src/context/shared/infrastructure/services/browser-telemetry";
import { BrowserErrorBoundary } from "./src/context/shared/infrastructure/ui/components/browser-error-boundary";

// Instrument before importing providers or mounting their initial requests.
const AppProviders = lazy(() =>
  initializeBrowserTelemetry().then(
    () => import(/* webpackChunkName: "app-providers" */ "./app-providers.web")
  )
);

const App = (): React.ReactElement => {
  return (
    <BrowserErrorBoundary>
      <Suspense fallback={null}>
        <AppProviders />
      </Suspense>
    </BrowserErrorBoundary>
  );
};

// eslint-disable-next-line import/no-default-export -- Expo AppEntry requires a default component.
export default App;
